"use client";

import AccessButton from "@/components/access-button";
import PricingCards from "@/components/pricing-cards";
import { Timeline } from "@/components/timeline";
import { cn } from "@/lib/utils";
import { useUserStore, type UserRole } from "@/store/store";
import { useEffect } from "react";
import { useLocale, useTranslations } from "next-intl";
import { useRouter } from "@/i18n/routing";

interface PricingPageContentProps {
  role: UserRole;
}

export function PricingPageContent({ role }: PricingPageContentProps) {
  const t = useTranslations("pricing");
  const locale = useLocale();
  const router = useRouter();
  const { role: currentRole } = useUserStore();

  useEffect(() => {
    if (currentRole !== role) {
      router.replace(`/${currentRole}/pricing`, { locale });
    }
  }, [currentRole, role, router, locale]);

  return (
    <main className="min-h-[calc(100vh-3.64rem)]  lg:min-h-[calc(100vh-4.5rem)] px-6 md:px-12">
      <section className="pt-[3.64rem] lg:pt-[4.5rem] pb-20">
        <div className="flex flex-col justify-center items-center gap-4 py-12 md:py-24">
          <h1 className="text-5xl md:text-7xl max-w-3xl text-center">
            {role === "trainer" ? t("title") : t("title_client")}{" "}
            {role === "trainer" ? (
              <span className="text-transparent bg-gradient-to-l from-primary to-second-primary bg-clip-text">
                {" "}
                {t("title_highlight")}
              </span>
            ) : null}
          </h1>
          <p
            className={cn("font-poppins text-2xl md:w-1/2 text-center", {
              "text-muted-foreground": role === "client",
            })}
          >
            {role === "trainer" ? t("description") : t("description_client")}
          </p>
          {role === "client" && <AccessButton />}
        </div>
        {role === "trainer" ? <PricingCards t={t} /> : <Timeline />}
      </section>
    </main>
  );
}

